import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-plus\"><path d=\"M11.221 12.779H5.25V11.22h5.971V5.25h1.558v5.971h5.971v1.558h-5.971v5.971H11.22v-5.971Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol